module.exports = __webpack_public_path__ + "img/acc.ad4a7b66.jpg";